<template>
	<div>
		<case-form :schema="schema" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"

export default {
	components: {
		CaseForm
	},

	computed: {
		schema() {
			return [
				{
					label: `请列出您现正服用或使用的任何处方药物或成药。`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0medicationsCurrentlyTakingCN`,
					props: {
						suggest: {
							typeIncludes: `medicationsCurrentlyTakingCN`
						},
						createOptions: {
							type: `medicationsCurrentlyTakingCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "身高 (米)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0heightInCentimetersCN`,
					props: {
						suggest: {
							typeIncludes: `heightInCentimetersCN`
						},
						createOptions: {
							type: `heightInCentimetersCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "体重 (厘米)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0weightInKilogramsCN`,
					props: {
						suggest: {
							typeIncludes: `weightInKilogramsCN`
						},
						createOptions: {
							type: `weightInKilogramsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "去年体重增加了吗？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasGainedWeightInPastYearCN`,
					props: {
						suggest: {
							typeIncludes: `hasGainedWeightInPastYearCN`
						},
						createOptions: {
							type: `hasGainedWeightInPastYearCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "去年体重减少了吗？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasLossWeightInPastYearCN`,
					props: {
						suggest: {
							typeIncludes: `hasLossWeightInPastYearCN`
						},
						createOptions: {
							type: `hasLossWeightInPastYearCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如果是，请提供详情，包括数值及改变的原因：",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0weightChangeReasonCN`,
					props: {
						suggest: {
							typeIncludes: `weightChangeReasonCN`
						},
						createOptions: {
							type: `weightChangeReasonCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
